module.exports = __webpack_public_path__ + "img/11_zh.62f19099.png";